import React, { useEffect, useReducer } from 'react'

import { Box, Dialog, Tooltip, Button, DialogTitle, DialogContent, Divider, Grid } from '@mui/material'

import CloseIcon from '@mui/icons-material/Close'
import { categories } from '../../Crm/TabTables/NotificationTable'
import { lockedReducer } from '../../../utils/defaultReducer'
import Loading from '../../Loading'
import api from '../../../api'
import { getSession } from '../../../auth'
import useNotification from '../../Notification'
import VisualizeTemplate from '../../Templates/360dialog/Modal/VisualizeTemplate'
import { showTemplateFunc } from '../../Crm/TabTables/NotificationTable'

const initialize = async (chatid, setState, handleClose) => {
    const enterpriseId = getSession().profile.enterprise.id
    setState({loading: true})
    const res = await api.get(`api/enterprises/${enterpriseId}/notifications/?id=${chatid}`)
    const result = {loading: false}
    if (res.status === 200){
        const data = (res.data?.results || []).pop()
        if (data) 
            showTemplateFunc(data, ()=>{}, (parsedTemplate)=>{
                result.data = parsedTemplate
            })
        
    } else {
        setState({loading: false})
        useNotification(
            'Ops!',
            'Falha ao carregar os dados',
            'danger'
        )
        handleClose()
    }
    setState(result)
}

const TemplateVisualizeDialog = ({ chatid, handleClose }) => {

    const [state, setState] = useReducer(lockedReducer, {
        data: null,
        loading: false
    })

    useEffect(() => {
        initialize(chatid, setState, handleClose)
    }, [])

    return (
        <Box>
            <Loading loading={state.loading} />
            <Dialog
                open={true}
                keepMounted
                onClose={() => { }}
                aria-describedby="alert-dialog-slide-description"
                fullWidth
                maxWidth="sm"
            >

                <DialogTitle className={'group-flexbox'}>
                    <span>Notificação</span>
                    <Tooltip title="Fechar" >
                        <Button className="action-button"  >
                            <CloseIcon onClick={handleClose} />
                        </Button>
                    </Tooltip>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    {state.data &&
                        <Grid container spacing={3}>
                            <VisualizeTemplate
                                template={state.data}
                                category={categories[state.data?.category]}
                                canVisualize={true}
                                processed={true}
                            />
                        </Grid>}
                </DialogContent>
            </Dialog>
        </Box>
    )

}

export default TemplateVisualizeDialog